import React, { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem("medina_token"));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("medina_user") || "null"));

  const api = useCallback(async (path, options = {}) => {
    const headers = { "Content-Type": "application/json", ...options.headers };
    if (token) headers.Authorization = `Bearer ${token}`;
    if (options.body instanceof FormData) delete headers["Content-Type"];

    const res = await fetch(path, { ...options, headers });
    if (res.status === 401) { logout(); throw new Error("Session expired"); }
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: "Request failed" }));
      throw new Error(err.error || "Request failed");
    }
    if (options.download) return res.blob();
    return res.json();
  }, [token]);

  const login = async (email, password) => {
    const data = await api("/api/auth/login", { method: "POST", body: JSON.stringify({ email, password }) });
    setToken(data.token);
    setUser(data.user);
    localStorage.setItem("medina_token", data.token);
    localStorage.setItem("medina_user", JSON.stringify(data.user));
    return data.user;
  };

  const logout = () => {
    setToken(null); setUser(null);
    localStorage.removeItem("medina_token");
    localStorage.removeItem("medina_user");
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, api, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
